import axiosCommon from '@/axios-common/axios-common';
import InfiniteLoading from 'vue-infinite-loading';
import vSelect from 'vue-select';
import {thumbnail} from '../../../config';

export default {
    name: 'newsletterDashboard',
    dependencies:['localeService'],
    components: {
        InfiniteLoading,
        vSelect
    },
    mounted() {
        this.initialize()
    },
    data() {
        return {
            newsletters: [],
            search: {
                months: '',
                years: ''
            },
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ],
            years: [],
            thumbnail,
            skip: 0,
            take: 5
        }
    },
    methods: {
        initialize() {
            let vm = this;

            vm.initializeYears();

            return vm.getNewsletters()
                .then(function (res) {
                    if (res.data.length > 0) {
                        vm.newsletters = res.data;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        initializeYears() {
            let vm = this;
            let now = new Date();
            for (let year = now.getFullYear() ; year >= 1900 ; year--) {
                vm.years.push(String(year));
            }
        },

        infiniteHandler($state) {
            let vm = this;
            vm.skip += vm.take;
            vm.getNewsletters()
                .then(function (res) {
                    vm.newsletters = vm.newsletters.concat(res.data);
                    $state.loaded();
                    if(res.data.length == 0){
                        $state.complete()
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });

        },
        filter() {
            let vm = this;
            vm.skip = 0;
            vm.take = 0;
            vm.getNewsletters()
                .then(function (res) {
                    vm.newsletters = res.data;
                })
                .catch(function (err) {
                    console.log(err);
                    return err;
                });
        },
        getNewsletters() {
            let vm = this;
            return axiosCommon.get(`o/newsletters?language=${vm.localeService.getCurrentLocale()}&skip=${vm.skip}&take=${vm.take}&months=${vm.search.months.toString()}&years=${vm.search.years.toString()}`)
                .then(function (res) {
                    return res;
                })
                .catch(function (err) {
                    return err;
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/newsletter-dashboard/newsletter-dashboard.js